<template>
  <div :class="showMenuNavigation ? 'mt-16' : 'mt-4'">
    <XsMenuNavigation
      v-if="showMenuNavigation"
      :fixed="true"
      :menuItems="menuItems"
    />
    <v-row
      v-if="selectedSection"
      class="background-color-white mb-3"
      no-gutters
    >
      <v-col cols="12">
        <div class="pl-4 py-2">
          <h4 class="font-weight-medium">{{ selectedSection }}</h4>
        </div>
      </v-col>
      <v-col cols="12">
        <v-sheet :max-width="fixedRowWidth">
          <v-row no-gutters class="px-2">
            <v-col
              v-for="item in menuItems[selectedSection]"
              :key="item.upc"
              cols="6"
              class="d-flex justify-center mb-4"
            >
              <Product :product="item" :size="'xs'" />
            </v-col>
          </v-row>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { slug } from "github-slugger";
import Product from "@/components/Product/index.vue";
import XsMenuNavigation from '@/components/Menu/Xs/Navigation.vue';
import { mapState, mapGetters } from 'vuex';

export default {
  name: "XsMenu",
  components: { Product, XsMenuNavigation },
  computed: {
    ...mapState({
      websiteFormat: (state) =>
        state.store.info.store_info.customization?.website.style
          .website_format ?? "all_items",
    }),
    ...mapGetters('menu', ['selectedSection']),
    fixedRowWidth() {
      return this.innerWidth;
    },
    hasSections() {
      return Object.keys(this.menuItems ?? {}).length > 1;
    },
    showMenuNavigation() {
      return this.hasSections && this.$route.name === 'menu';
    },
  },
  created() {
    window.addEventListener("resize", this.setInnerWidth);
  },
  data() {
    return {
      innerWidth: window.innerWidth,
    };
  },
  destroyed() {
    window.removeEventListener("resize", this.setInnerWidth);
  },
  methods: {
    setInnerWidth(event) {
      this.innerWidth = event.target.innerWidth;
    },
    slug,
  },
  props: { menu: Object, menuItems: Object },
};
</script>
